import React, { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import gaTracker from "@/ga";
import { Icon } from '@iconify/react';
import { hotBg, rank1, rank2, rank3 } from "@/config/config";
import { APIGetHomeSectionLast } from "@/api";
import styles from "./index.module.scss";
import useLanguage from "@/hooks/useLanguage";

const HotSaleBox = ({ obtain }) => {
  const router = useRouter();
  const { t, currentLang } = useLanguage();
  const [list, setList] = useState([]);
  const [hotSaleInfo, setHotSaleInfo] = useState();

  useEffect(() => {
    APIGetHomeSectionLast().then(res => {
      console.log('~res', res);
      setList(res?.data?.list?.products?.slice(0, 10));
      setHotSaleInfo(res?.data?.list);
    });
  }, []);

  // 如果hotSaleInfo为空，不展示组件
  if (!hotSaleInfo) {
    return null;
  }

  return (
    <div className={styles.hotSaleBox}>
      <div className={styles.header}>
        <img className={styles.bg} src={hotBg} alt='' />
        <div className={styles.left} onClick={() => {
          gaTracker.trackEvent("home_pop_title");
          router.push(`/hot-product-mobile/${hotSaleInfo?.id ?? 1}?country=${currentLang.code}&utm_source=homepage`);
        }}>
          <span className={styles.title}>{hotSaleInfo?.sectionName ?? ''}</span>
        </div>
        <div className={styles.right} onClick={() => {
          gaTracker.trackEvent("home_pop_more");
          router.push(`/hot-product-mobile/${hotSaleInfo?.id ?? 1}?country=${currentLang.code}&utm_source=homepage`);
        }}>
          <span className={styles.more}>{t('hot_sale_h5.more') + ' >'}</span>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.group}>
          {list?.map((item, index) => (
            <div className={styles.item} key={index} onClick={() => {
              gaTracker.trackEvent("home_pop_product");
              router.push(`/details-mobile/${item.productId}?country=${currentLang.code}&pageSource=hotSale&saleId=${hotSaleInfo?.id ?? 1}`);
            }}>
              <div className={styles.imgBox}>
                <img className={styles.img} src={item?.alyImage ? item.alyImage : item.image} alt='' />
                {index < 3 && <div className={styles.rank}>
                  <img className={styles.rankImg} src={index === 0 ? rank1 : index === 1 ? rank2 : rank3} alt='' />
                </div>}
              </div>
              <div className={styles.info}>
                <div className={styles.title}>{t('hot_sale_h5.earn_per_sale')}</div>
                <div className={styles.price}> {`${obtain ? item?.showCapEarnPer ?? "-" : item?.showEarnPer ?? "-"}`}</div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HotSaleBox;